module.exports = __webpack_public_path__ + "static/media/432519025_325515266778578_2194790924318382775_n.1cbe8b88.jpg";